import React from "react";
import { formatoPorcentaje } from "../cmmsComun";
import "../cmms.css";

// Indicadores compartidos (progreso del contrato, mis servicios, reportes).

// Medidor simple: una proporcion contra el total (pista gris, valor en el turquesa de la marca).
export const Medidor = ({ valor, texto }) => (
    <div className="cmms-medidor">
        <div className="cmms-medidor-pista">
            <div className="cmms-medidor-valor" style={{ width: `${Math.min(Math.max(valor || 0, 0), 1) * 100}%` }} />
        </div>
        <span className="cmms-medidor-texto">{texto ?? formatoPorcentaje(valor)}</span>
    </div>
);

// Tarjeta de indicador: titulo, cifra principal y detalle.
export const Tile = ({ titulo, valor, detalle, children }) => (
    <div className="cmms-tile">
        <div className="cmms-tile-titulo">{titulo}</div>
        <div className="cmms-tile-valor">{valor}</div>
        {children}
        {detalle ? <div className="cmms-tile-detalle">{detalle}</div> : null}
    </div>
);

export const FilaTiles = ({ children }) => <div className="cmms-tiles">{children}</div>;
